import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementAwaitingSwitchReadings_Agreement on AgreementType {
            status
        }
    `),
}

export function isAgreementAwaitingSwitchReadings(
    fragment: FragmentOf<typeof graphQLFragments.agreement>
) {
    const agreement = readFragment(graphQLFragments.agreement, fragment)

    return agreement.status === "AWAITING_SWITCH_READINGS"
}

isAgreementAwaitingSwitchReadings.fragments = graphQLFragments
